module.exports = __webpack_public_path__ + "static/GPlogoWebPage-a24143487f9ff3ffccc657d3da6a6f9c.png";